import {
  Step,
  StepConnector,
  stepConnectorClasses,
  stepIconClasses,
  StepLabel,
  stepLabelClasses,
  Stepper,
} from '@mui/material'
import { styled, SxProps } from '@mui/material/styles'

export const CustomConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 25,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: '#C7C6C6',
    borderRadius: 1,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: '#DE2826',
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: '#DE2826',
  },
}))

export const CustomStepper: React.FC<{
  steps: string[]
  activeStep: number
  sx?: SxProps
  onClick?: (step: number) => void
}> = ({ steps, activeStep, onClick, sx }) => {
  return (
    <Stepper
      alternativeLabel
      activeStep={activeStep}
      connector={<CustomConnector />}
      sx={{ padding: 4, ...sx }}
    >
      {steps.map((label, index) => (
        <Step key={label} sx={{ cursor: 'pointer' }} onClick={() => onClick?.(index)}>
          <StepLabel
            sx={{
              [`& .${stepLabelClasses.label}`]: {
                fontWeight: index <= activeStep ? 'bold' : 'normal',
                color: index <= activeStep ? '#DE2826 !important' : '#939090 !important',
              },
              [`& .${stepIconClasses.root}`]: {
                width: 50,
                height: 50,
                color: index <= activeStep ? '#DE2826 !important' : '#C7C6C6 !important',
                zIndex: 1,
              },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}
